module.exports = "https://cdn.dove.it/_next/static/public/assets/agencies/offer.c017f8f7a9c5c48eacfa77097f76b8a7.jpg";